export { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
export { LikeOutlined, LikeFilled } from "@ant-design/icons";
export type { IconLookup } from "@fortawesome/fontawesome-svg-core";
